module.exports = __webpack_public_path__ + "static/media/blackDisabledDashboardIcon.c37815fa.svg";